import { XCircleIcon } from '@heroicons/react/16/solid';
import { FC } from 'react';

type ErrorMessageProps = {
  errorMessage: string;
};

const ErrorMessage: FC<ErrorMessageProps> = ({ errorMessage }) => {
  return (
    <div className="w-full rounded-md bg-red-50 p-4">
      <div className="flex self-start">
        <div className="shrink-0">
          <XCircleIcon className="size-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">{errorMessage}</h3>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
